<template>
    <div class="history-management-view">
      <div class="documentmanagement-header">Invoices History</div>
      <div class="subsidiary-container">
        <div class="subsidiary-content">
          <div class="sub-header" >
            <h4 class="subsidiary-title">Invoice List</h4>
          </div>
          <table class="subsidiary-list">
            <thead>
              <tr>
                <th v-if="total_view">Company <br>Admin</th>
                <th>Invoice number</th>
                <th>Billing Period</th>
                <th>Issue Date</th>
                <th>Amount</th>
                <th>Status</th>
                <th class="flex justify-end">Action</th>

              </tr>
            </thead>
            <tbody v-if="fileList">
              <tr class="account-list" v-for="(file, index) in fileList">
                <td v-if="total_view">
                  <router-link :to="`/admin/users/${file.user_id}`" class="hoverable">
                    {{ file.username }}
                  </router-link>
                </td>

                <td >
                  <div class='attachment' @click="downloadFile(file.file_id, {'name': file.number}, true)">
                    <img src="@/assets/pdf-file.svg" class='fileicon'>
                    <div class="filename">
                      <div class="name-of-the-file">{{ file.number}}.pdf</div>
                      <div v-if="file.filesize" class="size-of-the-file">{{ Utils.calculateFileSize(file.filesize) }}</div>

                    </div>
                  </div>
                </td>
                <td class="user-info"> 
                  <div class="user-name">
                    {{ formatDate(file.billingPeriodStart) }} - 
                    {{ formatDate(file.billingPeriodEnd) }}
                  </div>
                </td>
                <td class="user-info"> 
                  <div class="user-name">
                    {{ formatDate(file.creationDate) }}
                  </div>
                </td>
                <td>{{ file.total_amount.toFixed(2) }} €</td>
                <td>{{ file.is_payed ? 'Payed' : 'Not Payed' }} </td>
                <td>   
                  <div class="flex gap-10 justify-end">
                    <div
                      class="icon-wrapper"
                      @click.stop="downloadFile(file.file_id, {'name': file.number})">
                      <img 
                        title="Download File"
                        src="@/assets/download.svg" class='icon download' >
                    </div>
                    <div  @click="viewFile(file)" class="icon-wrapper">
                      <img title="View Data" src="@/assets/password-look.svg" class='icon' />
                    </div>
                    <button v-if="(total_view || account_id) && !file.is_payed" class="w-content" @click="() => confirmPayed = file">
                      Mark as Payed
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class='no-data-present no-data-presents' v-if="fileList && fileList.length == 0">
            Nothing here yet
          </div>
        </div>
      </div>
           
      <PopupCover v-if="previewData"  @close="() => previewData = false">
        <PopupBody @close="() => previewData = false" style="width: 720px; max-width: 90vw; margin: auto; max-height: 90vh; overflow: auto;">
          <template #header> Invoice {{ previewData.number }}</template>
          <template #body>
            <div class="flex column gap-20 border-box">
                <div class="flex flex col gap-10 w-full invoice-preview p-20 border-box">
                    <div class='html-preview w-full' v-html="previewData.html" ></div>
                </div>
                <div class="flex justify-end gap-10">
                    <!-- <button class="button w-content" @click="confirmCreate()">Create</button> -->
                </div>
            </div>
          </template>
        </PopupBody>
      </PopupCover>


      <PopupCover v-if="confirmPayed"  @close="() => confirmPayed = false">
        <PopupBody @close="() => confirmPayed = false" style="width: 500px; max-width: 90vw; margin: auto; max-height: 90vh; overflow: auto;">
          <template #header> Confirm Invoice is payed</template>
          <template #body>
            Are you sure you want to mark invoice {{ confirmPayed.number }} as payed?
            <div class="flex justify-end gap-10 mt-20 column">
                <InpComponent
                    :label="'Pay Date'"
                    type="date"
                    :no-margin="true"
                    @inputChange="payDate = $event[1];"
                />
                <div class="flex justify-end gap-10 mt-20">
                  <button class="button w-content transparent" @click="confirmPayed = false">Cancel</button>
                  <button class="button w-content" :disabled="!payDate" @click="markAsPayed()">Confirm</button>
                </div>
            </div>
          </template>
        </PopupBody>
      </PopupCover>
    </div>
  </template>
    
  <script setup>
    import API from '@/api/index.js'
    import BO_API from '@/api/bo_api.js'
    import PopupBody from '@/components/PopupBody.vue';
    import PopupCover from '@/components/PopupCover.vue';
    import InpComponent from '@/components/InpComponent.vue';
    import { ref, onMounted, computed } from 'vue';
    import store from '../store';
    import Utils from '@/utils';
  
    const fileList = ref(null)
    const showErrors = ref(false);
  
    const props = defineProps(['account_id', 'total_view'])
  
    const confirmPayed = ref(false);
    const payDate = ref(null);



    onMounted(async () => {
      document.title = 'Invoices';
      const invoices = await API.invoices(props.account_id, props.total_view);
      fileList.value = invoices.invoices;
    })
  
    const previewData = ref(null);
  
    function formatDate(date) {
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return new Date(date).toLocaleDateString('en-GB', options);
    }
 
    function viewFile(file) {
      previewData.value = file
    }

    function downloadFile(file_id, filename) {
      store.dispatch('addNotification', {text: `Your file ${filename.name} is being downloaded`, type: 'success'});
      API.downloadInvoiceFile(file_id, filename);
    }

    function viewError(file) {
      showErrors.value = JSON.parse(file.errorList);
    }
    async function markAsPayed(){
      await BO_API.markInvoiceAsPayed(confirmPayed.value.file_id, payDate.value);
   
      const invoices = await API.invoices(props.account_id, props.total_view);
      fileList.value = invoices.invoices;

      store.dispatch('addNotification', {text: `Invoice ${confirmPayed.value.number} marked as payed`, type: 'success'});
      confirmPayed.value = false;
      payDate.value = null;
    }
  
  </script>
    
    
    
    <style scoped lang="scss">
  
  
  
    h4 {
      margin: 0;
    }
  
    .subsidiary-content {
      min-width: 100%;
      border: 1px solid #ccc;
      border-radius: 10px;
      width: fit-content;
    }
    .documentmanagement-header {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 20px;
      text-align: left;
      color: black;
      padding-top: 20px;
    }
    .history-management-view {
      display: flex;
      padding: 20px;
      flex-direction: column;
      max-width: 1350px;
      margin: auto;
    }
    .subsidiary-container {
          width: 100%;
      }
      
      .subsidiary-content {
          min-width: 100%;
          border: 1px solid #ccc;
          border-radius: 10px;
          width: fit-content;
      }
      
      .sub-header {
          border-top-right-radius: 10px;
          border-top-left-radius: 10px;
          padding: 20px;
          padding-left: 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background-color: white;
      }
      
      .subsidiary-title {
          display: flex;
          justify-content: space-between;
          color: black;
          font-size: 20px;
      }
      
      .sub-header {
          display: flex;
          justify-content: space-between;
          button {
              width: fit-content;
              padding: 10px;
          }
      }
      .subsidiary-list {
          padding: 20px;
          width: 100%;
          border-collapse: collapse;
          th, td {
              // border: 1px solid #ccc;
              padding: 15px;
              text-align: left;
              border: none;
              padding-left: 30px;
              color: black;
          }
          td {
              padding-top: 5px;
              padding-bottom: 5px;
          }
          th {
              text-align: left;
              border: none;
          }
          tr {
              border-top: 1px solid #ccc;
          }
          tbody {
              tr {
                  cursor: pointer;
                  td {
                      background: white;
                  }
  
                  &:last-child {
                      td {
                          &:first-child {
                              border-bottom-left-radius: 10px;
                          }
                          &:last-child {
                              border-bottom-right-radius: 10px;
                          }
                      }
                  }
                  &:hover {
                      td {
                          background: #f9f9f9;
                      }
                  }
              }
          }
      }
      
      .error-button {
          background: #f04f4f;
          color: black;
          border: 1px solid #ffcccc;
      }
      .error-container {
    height: 50vh;
    background-color: #f8d7da; /* Light red background color */
    color: #721c24; /* Dark red text color */
    border: 1px solid #f5c6cb; /* Border color */
    padding: 15px;
    overflow-y: auto;
    margin: 10px 0;
    border-radius: 5px;
    text-align: left;
  }
  .error-message {
    font-weight: bold;
  }
  .error-header {
    margin-top: 0;
  }
  
  .message-attachments {
      display: flex;
      flex-direction: column;
      gap: 1rem;
  }
  .size-of-the-file {
      font-size: 0.8rem;
      color: rgb(116 119 127);
  }
  .details {
      :deep(p) {
          margin: 0;
      }
  }
  .name-of-the-file {
      display: flex;
      align-items: center;
      color: black;
      font-size: 1rem;
  
      text-align: left;
      overflow: hidden;
      //text-wrap: nowrap;
      text-overflow: ellipsis;
  }
  .fileicon {
      width: 40px;
      height: 40px;
  }
  .hoverable {
      cursor: pointer;
      text-decoration: underline;
      &:hover {
          text-decoration: none;
      }
  }
  
  .attachment {
      border-radius: .5rem;
      border-width: 1px;
      -moz-column-gap: .5rem;
      column-gap: .5rem;
      padding: .8rem;
      display: flex;
      align-items: center;
  }
  .html-preview {
    &:deep(*) {
        font-size: 12px;   
    }
    &:deep(p) {
        margin: 3px 0;
    }
    &:deep(.container-invoice){
        width: 700px;
    }
}

.icon-wrapper {
  width: 30px;
  height: 30px;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.2s ease;
  &:hover {
    background-color: #e6e6e6;
  }
}
.icon  {
  width: 20px;
  height: 20px;
}

.download {
  width: 15px;
  height: 15px;
}
</style>